import React from 'react';
import { Navigate } from 'react-router-dom';
import { AuthSessionLoading } from './AuthSessionLoading';
import { useAuth } from '../contexts/AuthContext';

type GuestRouteProps = {
  children: React.ReactNode;
};

export function GuestRoute({ children }: GuestRouteProps) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <AuthSessionLoading />;
  }

  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
